export const homeFilterEnLocale = {
  'homeFilter.city.placeholder': 'City or zip code',
  'homeFilter.date.placeholder': 'Dates of interest',
  'homeFilter.query.placeholder': 'Search by artist or event',
  'homeFilter.submit.label': 'Search',
} as const;

export const homeFilterEsLocale = {
  'homeFilter.city.placeholder': 'Ciudad o código postal',
  'homeFilter.date.placeholder': 'Fechas de interes',
  'homeFilter.query.placeholder': 'Buscar por artista, evento o recinto',
  'homeFilter.submit.label': 'Buscar',
} as const;
